import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmationDialogContent, {
  ConfirmationDialogContentProps
} from 'components/dialog/ConfirmationDialog/ConfirmationDialogContent';
import { Dialog, DialogTitle } from '@mui/material';

export interface ConfirmationDialogProps
  extends ConfirmationDialogContentProps {
  open: boolean;
  title: string;
  disabled?: boolean;
}

// ===============================|| CONFIRMATION DIALOG ||=============================== //

const ConfirmationDialog = (props: ConfirmationDialogProps): ReactElement => {
  const { t } = useTranslation();

  const { open, onClose, title, disabled, ...contentProps } = props;

  const handleClose = (): void => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='confirmation-dialog-title'
      aria-describedby='confirmation-dialog-description'
      sx={{ p: 3 }}
    >
      <DialogTitle id='confirmation-dialog-title'>{t(title)}</DialogTitle>

      <ConfirmationDialogContent
        {...contentProps}
        onClose={onClose}
        disabled={disabled}
      />
    </Dialog>
  );
};

export default ConfirmationDialog;
